export default "__VITE_ASSET__91667fff__"